import { useState } from 'react'
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  TablePagination,
  Typography,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { Plus as PlusIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'

import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  LoadingFeedback,
  Page,
  Permitted,
  ReportClientVenderDialog,
} from 'components'

import { useFetch, useFilter, usePagination } from 'hooks'

import PreRegistrationsTable from './components/PreRegistrationsTable'

import constants from 'constants/index'
import * as service from 'service'
import { routes } from 'Routes'

const PreRegistrationsMain = () => {
  const filter = useFilter()
  const history = useHistory()
  const [openExport, setOpenExport] = useState(false)

  const theme = useTheme()
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(5)

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { response, isLoading, refresh } = useFetch(
    service.dponet.preRegistrations.get,
    {
      ...{ ...filter.filters },
      typeClient: constants.preRegistration.CLIENT_TYPE,
      perPage,
      page,
    },
    [page, perPage, filter.filters],
  )

  const { response: responseSeller, isLoading: loadSeller } = useFetch(
    service.dponet.sellers.index,
    {
      kindNotIn: [constants.seller.PARTNER_KIND],
    },
  )

  const handleCreate = () =>
    history.push(routes.preRegistrations.new, {
      typeClient: constants.preRegistration.CLIENT_TYPE,
      type: constants.preRegistration.TYPE_TRIAL,
    })

  const handleExport = () => setOpenExport(true)

  return (
    <Page title="Clientes">
      <LoadingFeedback open={isLoading || loadSeller} />
      <Container maxWidth={false}>
        <ContentHeader
          title="Listagem"
          menu="Clientes"
          subtitle="Listagem dos clientes"
        >
          <Button variant="contained" color="primary" onClick={handleExport}>
            Exportar
          </Button>
          <Box ml={1}>
            <FilterButton setDrawerOpen={filter.setDrawerOpen} />
          </Box>
        </ContentHeader>
        <Card>
          <Box width="100%">
            <Grid container>
              <Grid item xs={6}>
                <Box
                  width="100%"
                  p={2}
                  height="100%"
                  display="flex"
                  alignItems="center"
                >
                  <Typography variant="h5">Clientes</Typography>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box p={2} display="flex" justifyContent="flex-end">
                  <Permitted
                    tag={constants.permissions.PRE_REGISTRATIONS.CREATE}
                  >
                    <Button
                      variant="outlined"
                      color="primary"
                      startIcon={<PlusIcon />}
                      onClick={handleCreate}
                    >
                      Criar trial
                    </Button>
                  </Permitted>
                </Box>
              </Grid>
            </Grid>
            <Divider />
          </Box>
          <PreRegistrationsTable
            preRegistrations={response?.data?.preRegistrations || []}
            refresh={refresh}
          />
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={response?.data?.meta?.totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </Card>
      </Container>
      <Filters filter={filter}>
        <input textfieldinput="true" label="Identificador" name="id" />
        <input textfieldinput="true" label="Cliente" name="name" />
        <input textfieldinput="true" label="Documento" name="document" />
        <select textfieldinput="true" label="Tipo de cliente" name="kind">
          <option value="" />
          <option value={constants.companies.KINDS.COMPANY}>
            Pessoa jurídica
          </option>
          <option value={constants.companies.KINDS.PERSONAL}>
            Pessoa física
          </option>
        </select>
        <input
          datepickerinput="true"
          label="Data de criação inicial"
          name="createdAtGt"
          data-target="createdAtLt"
          data-min
        />
        <input
          datepickerinput="true"
          label="Data de criação final"
          name="createdAtLt"
          data-target="createdAtGt"
          data-max
        />
        <select textfieldinput="true" label="Status" name="status">
          <option value=""></option>
          <option value={constants.preRegistration.STATUSES.INITIATED_STATUS}>
            Iniciado
          </option>
          <option value={constants.preRegistration.STATUSES.FINALIZED_STATUS}>
            Finalizado
          </option>
          <option value={constants.preRegistration.STATUSES.DEMO_STATUS}>
            Demonstração
          </option>
          <option value={constants.preRegistration.STATUSES.ALL_TRIAL_STATUS}>
            Gratuito
          </option>
          <option
            value={constants.preRegistration.STATUSES.TRIAL_LIMITED_STATUS}
          >
            Gratuito limitado
          </option>
          <option
            value={constants.preRegistration.STATUSES.TRIAL_COMPLETE_STATUS}
          >
            Gratuito completo
          </option>
          <option
            value={constants.preRegistration.STATUSES.TRIAL_CANCELED_STATUS}
          >
            Gratuidade cancelada
          </option>
        </select>
        <select
          autocompleteselectinput="true"
          compareByName
          name="sellerId"
          label="Executivo de vendas"
          optionvalues={responseSeller?.data?.sellers || []}
        />
        <select textfieldinput="true" name="origin" label="Origem">
          {constants.preRegistration.OPTION_ORIGINS.map((origin) => (
            <option key={origin.id} value={origin.id}>
              {origin.name}
            </option>
          ))}
        </select>
        <input textfieldinput="true" label="Cidade" name="cityEq" />
        <input textfieldinput="true" label="Estado" name="stateEq" />
        <input
          textfieldinput="true"
          label="Código do plano"
          name="planCodeEq"
        />
        <input textfieldinput="true" label="Segmento" name="segmentNameCont" />
      </Filters>
      {openExport && (
        <ReportClientVenderDialog
          open={openExport}
          setOpen={setOpenExport}
          params={filter.filters}
          isClient
        />
      )}
    </Page>
  )
}

export default PreRegistrationsMain
